<template>
    <div class="vx-row w-full p-3">
      <!-- {{ evaluacion.areas[0][0].asignaturas[0][0].preguntas[0].pregunta.created_at }} -->
      <div class="vx-col sm:w-3/4 w-full">
      <!-- ENCABEZADO -->
      <vx-card v-bind:title="evaluacion.nombreasignatura" title-color="primary">
        <div class="vx-row w-full">
          <div class="vx-col sm:w-1/4 w-full">
              <img src="https://plataforma.prolipadigital.com.ec/img/prolipa.a3e6ff1b.png" style="max-width: 200px; border-radius: 5px;">
          </div>
          <div class="vx-col sm:w-3/4 w-full pt-3 text-right">
              <div v-if="revisa_admin_salle!=1"><b>Estudiante:</b> {{usuario.nombres}} {{usuario.apellidos}} - {{usuario.cedula}}<br></div>
              <div v-else>
                  <b>Estudiante:</b> {{datos_docente_revisando}}
              </div>
              <b class="mt-1">Inicia:</b> {{configuracion.fecha_inicio}} - <b class="ml-1">Finaliza:</b> {{ configuracion.fecha_fin}} <br>
              <b>Observaciones: </b> <span v-if="configuracion.observaciones !== null && configuracion.observaciones != 'null'">{{configuracion.observaciones}}</span>
              <div class="mt-1">
                <p v-for="(item,key) in arregloPeriodos" :key="key">
                  <span v-if="item.id == configuracion.n_evaluacion"><b>Evaluación Seleccionada:</b> <span class="ml-1">{{ item.nombre }}</span></span>
                </p>
                <br>
              </div>
          </div>
        </div>
      </vx-card>
      <vx-card class="mt-5 mb-6 text-center" v-if="evaluacion_activa==1">
        <!--AREAS-->
        <!-- <div class="flex justify-center" style="flex-wrap: wrap;">
          <div v-for="(itemR, indexR) in evaluacion" :key="indexR">
            <vs-button type="line"  @click="ver_area(indexR,itemR)" class="m-1"> {{itemR.nombre_area}} </vs-button>
          </div>
        </div> -->
        <div class="flex justify-center" style="flex-wrap: wrap;">
          <div v-for="(itemR, indexR) in evaluacion" :key="indexR">
            <vs-button
              type="line"
              @click="ver_area(indexR, itemR)"
              class="m-1"
              :class="{'bg-success font-bold text-white': selectedIndex === indexR}"
            >
              {{ itemR.nombre_area }}
            </vs-button>
          </div>
        </div>
        <div v-for="(item, index) in evaluacion" :key="index">
          <div v-bind:id="'area_activa'+index" class="mt-6 text-left" v-if="mostrar">
            <div class="flex">
              <h5 class="ml-5">Asignaturas área: {{item.nombre_area}}</h5>
              <vs-button @click="arraySelected=item;exportarEvaluacion()" v-if="userAdminSalle" class="ml-5" style="margin-top: -5px;"><i class="fa-solid fa-file-export"></i> Exportar</vs-button>
            </div>
            <vs-collapse type="margin" accordion >
              <vs-collapse-item v-for="(itemA, indexA) in item.asignaturas" :key="indexA" icon-pack="feafther" icon-arrow="icon-arrow-down">
                <div slot="header" style="width: 100%;"  @click="paginacion2(1, itemA.preguntas.length, itemA.id_asignatura);"> Preguntas - {{itemA.nombre_asignatura}} </div>
                <div style="overflow-y: scroll; height:600px;" id="div_pregunta" >
                  <div v-if="revision_activa===false">
                    <vs-button   v-for="(itemP, indexP) in itemA.preguntas"  v-model="current_preg[indexA]" :key="indexP"
                    @click="paginacion2(indexP+1, itemA.preguntas.length, itemA.id_asignatura)" color='#8496a9'
                    :class="{ 'fino': true ,'guardado':  itemP.respuestas.length>0 || isGuardada(`${indexP + 1}${itemA.id_asignatura}`), 'active':currentPregIndex === indexP + 1, 'active-guardado': (currentPregIndex === indexP + 1) && (itemP.respuestas.length > 0 || isGuardada(`${indexP + 1}${itemA.id_asignatura}`))}">
                    {{ indexP +1}}
                    </vs-button>
                  </div>
                  <div v-else>
                    <vs-button :id="(indexP+1)+''+itemA.id_asignatura"  v-for="(itemP, indexP) in itemA.preguntas"  v-model="current_preg[indexA]" :key="indexP"
                    @click="paginacion2(indexP+1, itemA.preguntas.length, itemA.id_asignatura)" color='#8496a9'
                    :class="{ 'fino': true ,'guardada':  itemP.respuestas.length>0 || isGuardada(`${indexP + 1}${itemA.id_asignatura}`), 'active':currentPregIndex === indexP + 1}">
                    {{ indexP +1}}
                    </vs-button>
                  </div>
                  <div v-for="(itemP, indexP) in itemA.preguntas" :key="indexP" class="w-full mb-2" v-show="shouldShowPreguntas(indexP)">
                    <div :id="itemA.id_asignatura+''+(indexP+1)" class="w-full p-3" style="min-height: 380px; vertical-align: top; background: rgb(64,105,213); background: radial-gradient(circle, rgba(64,105,213,0.073564459963673) 20%, rgba(0,101,228,0.16600143475358897) 87%);">
                      <div class="mt-2" style="font-size: 17px; min-height: 50px; display: flex;" align="justify">
                        <div><b style="color: black; margin-right: 4px;">{{ indexP +1}}.- </b></div>
                        <div><b> <span v-html="itemP.descripcion"></span></b> </div>
                      </div>
                      <div class="mb-base text-right">
                          Pregunta de {{itemP.nombre_tipo}} sobre {{itemP.puntaje_pregunta}} pts.
                      </div>
                      <img @click="dataPregunta = itemP;popupMostrarImagen=true;"  v-if="itemP.img_pregunta !== null && itemP.img_pregunta !== 'null' && itemP.img_pregunta !== ''" :src="$data_url+'archivos/img/salle/img_preguntas/'+itemP.img_pregunta" style="max-width: 400px; border-radius: 5px; mix-blend-mode: multiply;" class="mb-base">
                      <div v-if="itemP.id_tipo_pregunta === 1" class="m-3" style="font-size: 15px;">
                        <div>
                          <div v-for="(itemRes, indexRes) in itemP.respuestas" :key="indexRes" style="display: none;">
                              {{opciones_check[itemRes.respuesta] = itemRes.respuesta}}
                          </div>
                        </div>
                        <div class="text-left mb-5" v-for="(itemO, indexO) in itemP.opciones" :key="indexO">
                          <div v-if="revision_activa===true" style="width: 10%; display: inline-block;" align="center">
                            <span v-if="(opciones_check[itemO.id_opcion_pregunta] || !opciones_check[itemO.id_opcion_pregunta]) && itemO.tipo == 1" style="color: #3DE090; font-size: 18px;">✔</span>
                            <span v-if="(opciones_check[itemO.id_opcion_pregunta] || !opciones_check[itemO.id_opcion_pregunta]) && itemO.tipo == 0" style="color: #E73A5A; font-size: 18px;"><b>X</b></span>
                          </div>
                          <div style="width: 85%; display: inline-block; text-align: left;" align="left">
                            <vs-checkbox  :disabled="revision_activa" v-model="opciones_check[itemO.id_opcion_pregunta]" :vs-value="itemO.id_opcion_pregunta" @input="guardarSeleccion(1, itemO, itemP.opciones, itemP.puntaje_pregunta, itemA, indexP)">
                              {{itemO.opcion}}
                              <img v-if="itemO.img_opcion !== null && itemO.itemO !== 'null' && itemO.itemO !== ''" :src="$data_url+'archivos/img/salle/img_preguntas/'+itemO.img_opcion" alt="">
                            </vs-checkbox>
                          </div>
                        </div>
                      </div>
                      <div v-if="itemP.id_tipo_pregunta === 3 || itemP.id_tipo_pregunta === 5"  class="m-3" style="font-size: 15px;">
                        <div>
                          <div v-for="(itemRes, indexRes) in itemP.respuestas" :key="indexRes" style="display: none;">
                              {{opciones[itemRes.id_pregunta] = itemRes.respuesta}}
                          </div>
                        </div>
                        <ul class="justify" v-for="(itemO, indexO) in itemP.opciones" :key="indexO">
                          <li class="mb-5">
                            <div v-if="revision_activa===true" style="width: 10%; display: inline-block;" align="center">
                              <span v-if="itemO.tipo == 1" style="color: #3DE090; font-size: 18px;">✔</span>
                              <span v-else style="color: #E73A5A; font-size: 18px;"><b>X</b></span>
                            </div>
                            <div style="width: 85%; display: inline-block;">
                              <vs-radio :disabled="revision_activa" v-model="opciones[itemO.id_pregunta]" :vs-value="itemO.id_opcion_pregunta" @input="guardarSeleccion(3, itemO, itemP.opciones, itemP.puntaje_pregunta,itemA,indexP)">
                                {{itemO.opcion}}
                                <img v-if="itemO.img_opcion !== null && itemO.itemO !== 'null' && itemO.itemO !== ''" :src="$data_url+'archivos/img/salle/img_preguntas/'+itemO.img_opcion" alt="">
                              </vs-radio>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="navigation-buttons" style="display: flex; flex-wrap: wrap; justify-content: space-between;">
                    <div style="flex-grow: 1; text-align: left;">
                      <vs-button type="relief" @click="anteriorPregunta(itemA.id_asignatura)" :style="{ display: currentPregIndex === 1 ? 'none' : 'block' }">← Pregunta anterior</vs-button>
                    </div>
                    <div style="text-align: right;">
                      <vs-button type="relief" @click="siguientePregunta(itemA.id_asignatura, itemA.preguntas.length)" :style="{ display: currentPregIndex === itemA.preguntas.length ? 'none' : 'block' }">Siguiente pregunta →</vs-button>
                    </div>
                  </div>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
      </vx-card>
      <vx-card class="mt-5 mb-6 text-center p-5" v-else>
        <br>
        <h5> {{alerta_evaluacion}} </h5>
        <br><br>
        <vs-button color="success" type="border" class="m-2" @click="$router.go(-1)"><b>← Volver</b></vs-button>
        <!-- <br><br>
        <h5 v-if="tipo_revisar_activo!=1">Si no visualiza su evaluación, recargue la página.</h5> -->
      </vx-card>
      <!-- FIN SECCION RESPONDER PREGUNTAS -->
      </div>
      <!-- SECCION TIEMPO, NAVEGACION -->
      <div class="vx-col sm:w-1/4 w-full">
        <vx-card v-if="evaluacion_activa==1">
          <div align="center">
          <div v-if="revision_activa===true" class="mb-6">
            <b>Preguntas</b> <br>
            <p><b>Sin Responder:</b> {{ cantidadPreguntasSinResponder }}</p>
            <p><b>Respondidas:</b> {{ cantidadPreguntasRespondidas }}</p>
            <br><br>
              <!-- <b style="font-size: 16px;">Calificación 100%</b> <br><br><br> -->
              <span style="font-size: 45px; color: #2974FE; border: 1px solid #d5d5d5; border-radius: 5px; padding: 20px 10px 20px 10px;">
                  {{ calificacion100 }} <span style="font-size: 25px;">/ 100</span>
              </span><br><br>
              <!-- <b>Total puntos: {{calificacion}}/{{totalPuntaje}}</b> -->
          </div>
          <div v-if="revision_activa===false"> Tiempo para resolver esta evaluación: </div>
          <!-- <div class="mt-3" style="font-size: 35px; color: #2974FE;">{{configuracion.tiempo_evaluacion}} minutos</div> -->
          <div class="reloj mb-6 mt-4" style="font-size: 40px; color: #2974FE;"></div>
          <div class="mb-6" v-if="!userAdminSalle">
            <b>Preguntas</b> <br>
            <p class="text-danger"><b>Sin Responder:</b> {{ cantidadPreguntasSinResponder }}</p>
            <p class="text-success"><b>Respondidas:</b> {{ cantidadPreguntasRespondidas }}</p>
            <br>
              <vs-button v-if="evaluacion_activa==1 && revision_activa===false" color="dark" type="gradient" class="mb-6" @click="openConfirmFinalizar()">Finalizar evaluación</vs-button>
              <vs-button v-if="revisa_admin_salle==1" color="dark" type="gradient" class="mb-6" @click="openConfirmFinalizar()">Finalizar evaluación</vs-button>
          </div>
          <div class="mb-3">
              <vs-button color="success" type="border" class="mx-1" @click="$router.go(-1)"><b>← Volver</b></vs-button>
          </div>
          </div>
        </vx-card>
      </div>
      <!-- FIN SECCION TIEMPO, NAVEGACION -->
      <!--MODALES-->
      <!--MODAL PARA MOSTRAR UNA CONFIRMACION Y LAS REGLAS DE LA EVALUACION-->
      <vs-popup classContent="popup-example" title="Advertencia" :active.sync="popupConfirmStart" @close="handleClose" :class="{ 'hide-close': !showCloseButton }">
        <!--COMENZAR EVALUACION-->
        <div v-if="intentosEvaluacion == 0">
          <p class="font-bold text-success" style="font-size:18px;text-align: center;">Al aceptar empezará a correr el tiempo, buena suerte!</p>
          <p class="mt-5 font-semibold" style="opacity: 0.8;">Advertencia:</p>
          <div class="bg-warning text-white mt-1" style="padding: 15px;border-radius: 10px;line-height: 22px;">
            <p><b><ion-icon name="warning-outline"></ion-icon></b>  No puedes cambiar de pestaña o cerrar el navegador de lo contrario tu evaluación finalizará</p>
          </div>
          <div class="flex justify-center mt-3">
            <img src="https://cdn-icons-png.flaticon.com/512/3344/3344374.png" width="150"/>
          </div>
          <div class="flex justify-center mt-5">
            <vs-button class="mr-3 mb-2" color="success" @click="acceptAlert()">Empezar</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="volver()">← Volver</vs-button>
          </div>
        </div>
        <!--CUANDO YA INICIO LA EVALUACION-->
        <div v-if="intentosEvaluacion == 1">
          <p class="font-bold text-danger text-center" style="font-size:18px;"> Usted ha abandonado la evaluación , la próxima vez su <b>evaluación finalizará</b></p>
          <div class="flex justify-center">
            <img src="https://cdn-icons-png.flaticon.com/512/2797/2797387.png" width="200"/>
          </div>
          <div class="flex justify-center">
            <!-- HTML !-->
            <button class="button-7" role="button" @click="acceptAlert()">Continuar Evaluación</button>
          </div>
        </div>
        <div v-if="intentosEvaluacion > 1">
          <p class="font-bold text-danger" style="font-size:18px;text-align: center;"><b> Evaluación suspendida</b></p>
          <div class="flex justify-center">
            <img src="https://cdn-icons-png.flaticon.com/512/3403/3403504.png" width="200"/>
          </div>
          <div class="flex justify-center">
            <vs-button color="warning" type="filled" class="mb-2 mt-3" @click="acceptAlert()">Aceptar</vs-button>
          </div>
        </div>
      </vs-popup>
      <!--MODAL PARA MOSTRAR QUE SI CAMBIA DE PESTANA SE FINALIZARA LA PRUEBA-->
      <vs-popup classContent="popup-example" title="Advertencia" :active.sync="popupIntentos">
        <p class="font-bold text-danger text-2xl">A la proximá que salgas tu <b>Evaluación Finalizará</b></p>
        <div class="flex justify-center">
          <img src="https://cdn-icons-png.flaticon.com/512/2797/2797387.png" width="200"/>
        </div>
        <div class="flex justify-center">
          <!-- HTML !-->
          <button class="button-7" role="button" @click="popupIntentos = false;">Entendido</button>
        </div>
      </vs-popup>
      <!--MODAL PARA MOSTRAR LA IMAGEN DE LA PREGUNTA-->
      <vs-popup class="holamundo" fullscreen title="Mostrar imagen" :active.sync="popupMostrarImagen">
        <div class="flex" style="justify-content: center;" v-if="popupMostrarImagen">
          <image-zoom
              :regular="$data_url+'archivos/img/salle/img_preguntas/'+dataPregunta.img_pregunta"
              :zoom-amount="3"
              :click-zoom="true"
              click-message="De click para aumentar"
              img-class="img-fluid"
              >
          </image-zoom>
        </div>
      </vs-popup>
      <!--modal para mostrar el reporte-->
      <vs-popup fullscreen title="Reporte de evaluación del área " :active.sync="popupMostrarReporte">
        <div v-if="popupMostrarReporte">
          <SalleReporteEvaluacionVue :arraySelected="arraySelected" :revision_activa="revision_activa" :datos_docente_revisando="datos_docente_revisando"/>
        </div>
      </vs-popup>
    </div>
</template>

<script>
    import imageZoom from 'vue-image-zoomer';
    import vSelect from 'vue-select'
    import $ from 'jquery'
    const SalleReporteEvaluacionVue = () => import('./components/SalleReporteEvaluacion.vue');
    export default {
      components: {
          'v-select': vSelect,
          imageZoom,
          SalleReporteEvaluacionVue
        },
        data(){
          return {
            areaActivaIndex: null,
            currentPregIndex: 1,
            usuario: [],
            evaluacion: [],
            area_activa: 0,
            opciones: [],
            opciones_check: {},
            opciones_guardadas: {},
            id_evaluacion: '',
            evaluacion_activa: 0,
            alerta_evaluacion: '',
            revision_activa: false,
            configuracion: [],
            color_overlay: '',
            text_overlay: '',
            tiempo_evaluacion: 0,
            calificacion100:0,
            calificacion: 0,
            totalPuntaje:0,
            dataaaa: [],
            current_preg: [],
            revisa_admin_salle: 0,
            datos_docente_revisando: '',
            arregloPeriodos:[],
            //variables para intentos de evaluacion
            intentosEvaluacion:0,
            popupIntentos:false,
            popupConfirmStart:false,
            showCloseButton:false,
            //fin variables para intentos de evaluacion
            //variables para mostrar la imagen
            dataPregunta:'',
            popupMostrarImagen:false,
            //SOLO UNA VEZ CORRERA EL TIEMPO
            correrTiempo:true,
            mostrar:false,
            userAdminSalle:false,
            arraySelected:'',
            popupMostrarReporte:false,
            cantidadPreguntasRespondidas:0,
            cantidadPreguntas:0,
            cantidadPreguntasSinResponder:0,
            seleccion:[],
            intervalId:null,
            selectedIndex: 0   // Por defecto se selecciona el primer botón
          }
        },
        created(){
          let me = this
          me.mostrar = false
          me.getPeriodosEvaluacion()
          me.usuario = JSON.parse(localStorage.getItem('usuario'));
          if( me.usuario.id_group == 12 ){
            me.userAdminSalle = true
          }
          me.tipo_revisar_activo = localStorage.tipo_revisar
          me.revisa_admin_salle = localStorage.revisa_admin_salle
          me.datos_docente_revisando = localStorage.datos_docente_revisando
          if( me.tipo_revisar_activo === '1' ){
              me.id_evaluacion = localStorage.id_evaluacion_salle
              me.obtener_evaluacion()
              me.obtenerCalificacion()
          }else{
              me.generarEvaluacion()
          }
          me.getConfiguracion()
        },
        mounted() {
          document.addEventListener("visibilitychange", this.handleVisibilityChange);
        },
        beforeDestroy() {
          let me = this
          document.removeEventListener("visibilitychange", this.handleVisibilityChange);
          clearInterval(this.intervalId);
          // Limpiar la referencia al intervalo
          this.intervalId = null;
          //limpiar el reloj
          document.getElementById("reloj").innerHTML = "";
        },
        computed: {
          shouldShowPreguntas() {
            return (indexP) => {
              return this.currentPregIndex === indexP + 1;
            }
          },
        },
        methods: {
          exportarEvaluacion(){
            let me = this
            me.popupMostrarReporte = true
          },
          handleClose() {
            let me = this;
            me.popupConfirmStart = true
          },
          volver(){
            let me = this;
            me.popupConfirmStart = false
            me.$router.go(-1)
          },
          handleVisibilityChange() {
            let me = this
            if (document.visibilityState === "hidden") {
              console.log("diconnect")
              // El usuario cambió de pestaña o minimizó el navegador
            } else {
              console.log("connect")
              //comentar esto para hacer pruebas
              // if((me.intentosEvaluacion == 1 || me.intentosEvaluacion == 2 ) && (this.usuario.id_group == 13 || this.usuario.id_group == 6)){
              //   me.popupConfirmStart = true;
              // }
              // El usuario volvió a la pestaña o maximizó el navegador
            }
          },
          getPeriodosEvaluacion() {
            let me = this;
            this.$http.get(this.$server_url+'salle/periodos')
              .then(function (response) {
                me.arregloPeriodos = response.data;
              })
              .catch(function (error) {
              })
          },
          async generarEvaluacion(){
            let me = this
            me.color_overlay = '#22c16b'
            me.text_overlay = 'Estamos preparando su evaluación, no tomará mucho tiempo'
            me.$vs.loading({ background: me.color_overlay, color: 'rgb(255, 255, 255)',  type: 'sound', text: me.text_overlay })
            await this.$http.get(this.$server_url+'generar_evaluacion_salle/' + me.usuario.idusuario+'/'+me.usuario.institucion_idInstitucion+'/'+localStorage.EvaluacionSelectSalle+'/0')
            .then(res => {
              if(res.data.status == 0){
                me.$vs.notify({title: 'Error', text: res.data.message, color: 'danger'})
                me.$vs.loading.close()
                return
              }
              if( res.data === 0 ){
                me.evaluacion_activa = 0
                me.revision_activa = true
                me.alerta_evaluacion = 'Lo sentimos el tiempo para resolver esta evaluación ha terminado.'
                me.$vs.loading.close()
                return
              }
              if( res.data === 1 ){
                me.evaluacion_activa = 0
                me.revision_activa = true
                me.alerta_evaluacion = 'La institución a la que pertenece necesita ser configurada, por favor comuníquese con el administrador del sistema.'
                me.$vs.loading.close()
                return
              }
              if( res.data === 2 ){
                me.evaluacion_activa = 0
                me.revision_activa = true
                me.alerta_evaluacion = 'Su evaluación ha finalizado.'
                me.$vs.loading.close()
                return
              }

              me.evaluacion         = res.data
              me.id_evaluacion      = res.data[0].id_evaluacion
              me.f_estadoPreguntas()
              me.intentosEvaluacion = res.data[0].intentos
              if((me.intentosEvaluacion == 0 || me.intentosEvaluacion == 1 || me.intentosEvaluacion == 2) && (me.usuario.id_group == 13 || me.usuario.id_group == 6)){
                me.openConfirm()
              }
              if(me.intentosEvaluacion > 2 && (me.usuario.id_group == 13 || me.usuario.id_group == 6)){
                me.popupConfirmStart = false
              }
              me.evaluacion_activa  = 1
              me.mostrar = true
              setTimeout(() => {
                me.ver_area(0)
              },1500)
              me.$vs.loading.close()
            })
            .catch(function (error) {
              console.log(error);
              me.$vs.loading.close()
            })
          },
          getConfiguracion(){
            let me = this
            var InstitucionUser = ""
            if( me.tipo_revisar_activo === '1' ){
              if(me.usuario.id_group == 13 || me.usuario.id_group == 6){
                InstitucionUser = me.usuario.institucion_idInstitucion
              }else{
                InstitucionUser = localStorage.idInstitucionDocente
              }
            }else{
              InstitucionUser = me.usuario.institucion_idInstitucion
            }
            me.$http.get(this.$server_url+'salle_getConfiguracion/' + InstitucionUser+'/'+localStorage.EvaluacionSelectSalle)
            .then(res => {
              me.configuracion = res.data.configuracion[0]
              //el administrador si puede ver las preguntas
              if(me.usuario.id_group == 12 && me.tipo_revisar_activo == 1){
              }else{
                 // alert(me.configuracion.ver_respuestas +'  &&  '+ me.tipo_revisar_activo)
                if( me.configuracion.ver_respuestas == 0 && me.tipo_revisar_activo == 1 ){
                  console.log('no puede ver las preguntas')
                  me.alerta_evaluacion = 'La revisión de sus evaluaciones está desactivada.'
                  if( me.revisa_admin_salle != 1 ){ // cuando revisa el admin no se bloquea
                    me.evaluacion_activa = 0
                  }
                }
              }

            })
            .catch(function (error) {
                console.log(error);
            })
          },
          ver_area(index){
            let me = this
            this.selectedIndex = index;
            for( var i=0; i<me.evaluacion.length; i++ ){
              document.getElementById("area_activa"+i).style.display = "none";
            }
            document.getElementById("area_activa"+index).style.display = "block";
            this.currentPregIndex = 1; // Reinicia al inicio.
          },
          async guardarSeleccion(tipo_pregunta, item, opciones, puntaje,activacion,index){
            let me = this
            if( me.tipo_revisar_activo === 1 ){ return } // no se guardan las respuestas en modo revision
            // se obtiene la cantidad de opciones correctas de la pregunta respondida
            let cant_correctas = 0
            $.each(opciones, function(key, value){
              if(value.tipo === 1){
                  cant_correctas++
              }
            })
            let opciones_seleccionadas = []
            $.each(me.opciones_check, function(key, value){
              for( var i=0; i<opciones.length; i++ ){
                if( key == opciones[i].id_opcion_pregunta ){
                  if(value !== false ){
                      opciones_seleccionadas.push(key)
                  }
                }
              }
            })
            let puntaje_seleccion = 0
            // alert(opciones_seleccionadas.length +' <= '+ cant_correctas)
            if( opciones_seleccionadas.length <= cant_correctas ){
              if( item.tipo === 1 ){
                //si la opcion seleccionada es de tipo correcta y no ha excedido la cantidad de opciones correctas
                puntaje_seleccion = (parseFloat(puntaje)/cant_correctas).toFixed(2)
                // alert('puntaje_seleccion bien: ' + puntaje_seleccion)
              }
            }else{
              // se le resta el puntaje cuando selecciona mas opciones de las correctas
              puntaje_seleccion = parseFloat(puntaje)*(-1)
              // alert('puntaje_seleccion else: ' + puntaje_seleccion)
            }
            let dataSeleccion = {
              id_evaluacion: me.id_evaluacion,
              id_usuario: me.usuario.idusuario,
              id_pregunta: item.id_pregunta,
              id_opcion_pregunta: item.id_opcion_pregunta,
              tipo_pregunta: tipo_pregunta,
              puntaje_seleccion: puntaje_seleccion
            }
            await me.$http.post(this.$server_url+'salle_guardarSeleccion', dataSeleccion)
            .then(res => {
              if(res.data.status == 0){
                me.$vs.notify({
                  title: 'Error',
                  text: res.data.message,
                  color: 'danger',
                  position: 'top-right'
                })
              }
              me.f_estadoPreguntas()
              me.cambiarAguaradoPregunta(activacion.id_asignatura, index+1)
            })
            .catch(function (error) {
              console.log(error);
            })
          },
          f_estadoPreguntas(){
            let me = this
            // me.cantidadPreguntasRespondidas     = 0
            //   me.cantidadPreguntas              = 0
            //   me.cantidadPreguntasSinResponder  = 0
              me.$http.get(this.$server_url+'f_estadoPreguntas/'+ me.id_evaluacion )
              .then(res => {
                me.cantidadPreguntasRespondidas   = res.data.cantidadPreguntasRespondidas
                me.cantidadPreguntas              = res.data.cantidadPreguntas
                me.cantidadPreguntasSinResponder  = me.cantidadPreguntas - me.cantidadPreguntasRespondidas
              })
          },
          openConfirm() {
            let me = this;
            me.popupConfirmStart = true
            // this.$vs.dialog({
            //   type: 'confirm',
            //   color: 'success',
            //   title: `¿Listo para empezar?`,
            //   acceptText:'Empezar',
            //   cancelText:'Cancelar',
            //   text: 'Al aceptar empezará a correr el tiempo, buena suerte!',
            //   accept: this.acceptAlert
            // })
          },
          acceptAlert() {
            let me = this
             if(me.intentosEvaluacion > 1){
              me.popupConfirmStart = false
              this.saveIntento()
              me.generarEvaluacion()
              return
            }
            me.popupConfirmStart = false
            this.saveIntento()
            document.getElementById("area_activa0").style.display = "block";
            if(me.correrTiempo){
              me.correrTiempo = false
              this.f_tiempo()
            }
          },
          saveIntento(){
            let me = this;
            //si es docentes cuantos los intentos
            if(me.usuario.id_group == 13 || me.usuario.id_group == 6){
              let formData = new FormData();
              formData.append('id_evaluacion',me.id_evaluacion);
              formData.append('id_usuario',   me.usuario.idusuario)
              formData.append('intentosEval', me.intentosEvaluacion)
              this.$http.post(this.$server_url+'save_finalizar_evalIntentos', formData)
              .then(res => {
                me.intentosEvaluacion = res.data.intentos
              })
            }
          },
          f_tiempo() {
            let me = this
            let cant_preguntas = 0
            $.each(me.evaluacion, function(key, value){
              $.each(value.asignaturas, function(keyA, valueA){
                  $.each(valueA.preguntas, function(keyP, valueP){
                      cant_preguntas++
                  })
              })
            })
              // todas las preguntas tienen una duracion de 3 minutos
              var n = (cant_preguntas * 3) * 60;
              me.tiempo_evaluacion = n
              this.intervalId = setInterval(function() {
                n--;
                var now = n * 1000;
                var distance = n + now;
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                $(".reloj").html(hours + " : " + minutes + " : " + seconds + "");
                if (distance < 60000) {
                    $(".reloj").css('color', '#FB2452');
                }
                if (distance < 0) {
                    $(".reloj").html("Fin del tiempo");
                    me.finalizarEvaluacion()
                }
              }, 1000);
            },
            openConfirmFinalizar() {
              let me = this
              let mensaje = "¿Está seguro de finalizar esta evaluación?"
              //si hay preguntas sin responder
              if( me.cantidadPreguntasSinResponder > 0 ){
                mensaje =  `Tienes ${me.cantidadPreguntasSinResponder} preguntas sin responder, ¿Desea finalizar la evaluación?`
              }
              this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: mensaje,
                text: 'Sus respuestas serán enviadas para calificar.',
                accept: this.finalizarEvaluacion,
                acceptText: 'Aceptar',
                cancelText:'Cancelar'
              })
            },
            finalizarEvaluacion(){
              let me = this
              let id_usuario_eval = me.usuario.idusuario
              if( localStorage.idusuario_evaluacion_salle ){
                id_usuario_eval = localStorage.idusuario_evaluacion_salle
              }
              let data_finalizar = {
                id_evaluacion: me.id_evaluacion,
                id_usuario: id_usuario_eval
              }
              me.$vs.loading()
              me.$http.post(this.$server_url+'salle_finalizarEvaluacion', data_finalizar)
              .then(res => {
                me.color_overlay = '#90ABF3'
                me.text_overlay = 'Estamos calificando su evaluación, pronto podrá ver sus resultados.'
                if(res.data.status == 0){
                  //close
                  me.$vs.loading.close()
                  //error
                  me.$vs.notify({title: 'Error', text: 'No se pudo finalizar la evaluación, intente nuevamente.',color:'danger'})
                  return
                }
                location.reload()
              })
              .catch(function (error) {
                me.$vs.loading.close()
                console.log(error);
              })
            },
            obtenerCalificacion(){
              let me = this
              me.cantidadPreguntasRespondidas = 0
              me.cantidadPreguntas = 0
              me.cantidadPreguntasSinResponder = 0
              me.$http.get(this.$server_url+'obtenerCalificacion_salle/'+ me.id_evaluacion )
              .then(res => {
                if(res.data.status == 0){
                  me.$vs.notify({
                    title: 'Error',
                    text: res.data.message,
                    color: 'danger',
                    position: 'top-right'
                  })
                  return
                }
                let resultado     = 0
                me.calificacion   = res.data.calificacionFinal.toFixed(2)
                //totalPuntaje
                me.totalPuntaje   = res.data.totalPuntaje
                resultado         = (me.calificacion  / me.totalPuntaje) * 100
                me.calificacion100 = resultado.toFixed(2)
                me.cantidadPreguntasRespondidas = res.data.cantidadPreguntasRespondidas
                me.cantidadPreguntas = res.data.cantidadPreguntas
                me.cantidadPreguntasSinResponder = me.cantidadPreguntas - me.cantidadPreguntasRespondidas
              })
            },
            obtener_evaluacion(){
              let me = this
              me.revision_activa = true
              me.evaluacion_activa = 1
              me.color_overlay = '#22c16b'
              me.text_overlay = 'Estamos cargando su evaluación resuelta ...'
              me.$vs.loading({ background: me.color_overlay, color: 'rgb(255, 255, 255)',  type: 'sound', text: me.text_overlay })
              let id_usuario_eval = me.usuario.idusuario
              if( localStorage.idusuario_evaluacion_salle ){
                id_usuario_eval = localStorage.idusuario_evaluacion_salle
              }
              me.$http.get(this.$server_url+'obtener_evaluacion_salle/'+ me.id_evaluacion + '/' + id_usuario_eval +'/'+localStorage.EvaluacionSelectSalle)
              .then(res => {
                  let datos = res.data
                  me.evaluacion = datos
                  me.validacionBuenasXMalas = datos

                  let calificacion = 0
                  let calificacion_preg = 0
                  let cant_asignaturas = 0
                  let cant_areas = 0
                  let calificacion_pregunta = 0
                  let cant_preguntas = 0
                  let puntaje_preguntas = 0
                  let calificacion_asignatura = 0
                  let calificacion_areas = 0
                  /// ERROR EN CALCULO AQUI XQ NO ESTA CONSIDERNADO LOS VALORES NEGATIVOS COMO EN EL CONTROLADOR DE LOS REPORTES
                  // $.each(me.evaluacion.areas, function(key, value){
                  //   cant_areas++
                  //   $.each(value[0].asignaturas, function(keyA, valueA){
                  //     cant_asignaturas++
                  //     $.each(valueA[0].preguntas, function(keyP, valueP){
                  //       cant_preguntas++
                  //       puntaje_preguntas += valueP.pregunta.puntaje_pregunta
                  //       $.each(valueP.respuestas, function(keyRes, valueRes){
                  //         calificacion_preg = calificacion_preg + valueRes.puntaje
                  //       })
                  //       if( calificacion_preg >= 0 && calificacion_preg <= valueP.pregunta.puntaje_pregunta ){
                  //       }else{
                  //         if( valueP.pregunta.id_tipo_pregunta != 1 ){
                  //           calificacion_preg = valueP.pregunta.puntaje_pregunta
                  //         }else{
                  //           calificacion_preg = 0
                  //         }
                  //       }
                  //       calificacion_pregunta += calificacion_preg
                  //       calificacion_preg = 0
                  //     })
                  //   })
                  //   calificacion_areas += ((calificacion_pregunta*100)/puntaje_preguntas)
                  //   calificacion_pregunta = 0
                  //   puntaje_preguntas = 0
                  //   calificacion_asignatura = 0
                  //   cant_asignaturas = 0
                  // })
                  // me.calificacion = (calificacion_areas/cant_areas).toFixed(2)
                  //mostrar preguntas
                  me.mostrar = true
                  setTimeout(() => {
                    me.ver_area(0)
                  },1500)
                  me.$vs.loading.close()
              })
              .catch(function (error) {
                  me.$vs.loading.close()
                  console.log(error);
              })
            },
            paginacion(index, tam, asign_content){
              let me = this;
              for( let i=1; i<=tam; i++ ){
                  $('#'+asign_content+''+i).css('display', 'none')
              }
              $('#'+asign_content+''+me.current_preg[index]).css('display', 'block')
            },
            siguientePregunta(asignContent, totalPreguntas) {
              if (this.currentPregIndex < totalPreguntas) {
                this.paginacion2(this.currentPregIndex + 1, totalPreguntas, asignContent);
              }
            },
            anteriorPregunta(asignContent) {
              console.log("asignContent",asignContent)
              if (this.currentPregIndex > 1) {
                this.paginacion2(this.currentPregIndex - 1, 0, asignContent);
              }
            },
            paginacion2(indexP, totalPreguntas, asignContent) {
                // Oculta todas las preguntas
                for (let i = 1; i <= totalPreguntas; i++) {
                  const element = document.getElementById(`${asignContent}${i}`);
                  if (element) element.style.display = 'none';
                }
                // Muestra solo la pregunta actual
                const currentElement = document.getElementById(`${asignContent}${indexP}`);
                if (currentElement) currentElement.style.display = 'block';

                // Actualiza el índice de la pregunta activa
               this.currentPregIndex = indexP;
            },
            cambiarAguaradoPregunta(asign_content, indexP) {
              const id = `${indexP}${asign_content}`;
              if (!this.seleccion.includes(id)) {
                this.seleccion.push(id);
              }
            },
            isGuardada(id) {
              return this.seleccion.includes(id);
            },

        },
    }
</script>
<style scoped>
/* width */
#div_pregunta::-webkit-scrollbar {
  width: 10px;
}

/* Track */
#div_pregunta::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(211, 207, 241);
  border-radius: 10px;
}

/* Handle */
#div_pregunta::-webkit-scrollbar-thumb {
  background: #2e85e9;
  border-radius: 10px;
}

/* Handle on hover */
#div_pregunta::-webkit-scrollbar-thumb:hover {
  background: #2e85e9;
}
/* CSS */
.button-7 {
  background-color: #0095ff;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: rgba(255, 255, 255, .4) 0 1px 0 0 inset;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system,system-ui,"Segoe UI","Liberation Sans",sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.15385;
  margin: 0;
  outline: none;
  padding: 8px .8em;
  position: relative;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  white-space: nowrap;
}

.button-7:hover,
.button-7:focus {
  background-color: #07c;
}

.button-7:focus {
  box-shadow: 0 0 0 4px rgba(0, 149, 255, .15);
}

.button-7:active {
  background-color: #0064bd;
  box-shadow: none;
}
.fino {
  padding: 4px 8px !important;
  font-size: 12px !important;
  border-radius: 4px !important;
  margin: 5px;
  transition: background-color 0.3s ease, color 0.3s ease, border 0.3s ease;
  border: 2px solid transparent ;
}

.active {
  background-color: #5c5c5c !important;
  color: #fff !important;
  border: 2px solid #4b4b4b !important;
}

.guardada {
  background-color: #0275d8 !important;
  color: #fff !important;
  border: 2px solid transparent ;

}
.guardado {
  background-color: #31b53c !important;
  color: #fff !important;
  border: 2px solid transparent ;

}
.active-guardado {
  background-color: #2ea538 !important;
  color: #fff !important;
  border: 2px solid #1b5f21 !important;

}

.active-guardada {
  background-color: #5a5a5a !important;
  color: #fff !important;
  border: 2px solid transparent;

}
</style>
